import { transformLocalDirectories } from './localDirectoriesTransformer';

/**
 * Transforms Local section criteria from WooRank API response.
 * Scope: Local Directories only (legacy parity).
 *
 * @param {Object} apiData - full WooRank API response
 * @returns {Object} transformed Local section data
 */
export const transformLocalSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const localDirectories = transformLocalDirectories(criteria?.local_directories);

  const allResults = [localDirectories];
  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    localDirectories,
  };
};

export default transformLocalSection;


